﻿import { response_booking_info } from "./response_booking_info";
import { response_booking_agent } from "./response_booking_agent";

export class response_booking_identity {
    public booking_info: response_booking_info = new response_booking_info();
    public agents: response_booking_agent[] = [];
}